module.exports = __webpack_public_path__ + "media/img/covers/profile-cover-3-f86cc508c7f968b0f827d8988858a60a.jpg";